export enum SessionKeys {
  routeIds = 'routeIds',
  user = 'user',
}
